import React from "react";
import { array, arrayOf, shape, string, number, object } from "prop-types";
import { BRAND_CODE_LA } from "../../../../constants";
import RecommendedVideosDefault from "./brand/Default";
import RecommendedVideosLabArchives from "./brand/LabArchives";

const RecommendedVideos = ({ brandCode, videos }) => {
	const RecommendedVideosComponent = brand => {
		switch (brand.toLowerCase()) {
			case BRAND_CODE_LA:
				return RecommendedVideosLabArchives;
			default:
				return RecommendedVideosDefault;
		}
	};

	const RecommendedVideosBrand = RecommendedVideosComponent(brandCode);

	return <RecommendedVideosBrand videos={videos} />;
};

RecommendedVideos.propTypes = {
	brandCode: string,
	videos: arrayOf(
		shape({
			fields: shape({
				body: object, // eslint-disable-line react/forbid-prop-types,
				lead: string,
				metaDescription: string,
				slug: string,
				thumbnail: shape({
					fields: shape({
						description: string,
						file: shape({
							contentType: string,
							details: shape({
								image: shape({
									height: number,
									width: number,
								}),
								size: number,
							}),
							fileName: string,
							url: string,
						}),
						title: string,
					}),
					metadata: shape({
						tags: array, // eslint-disable-line react/forbid-prop-types,
					}),
					sys: object, // eslint-disable-line react/forbid-prop-types,
				}),
				title: string,
				toClick: string,
			}),
			metadata: shape({
				tags: array, // eslint-disable-line react/forbid-prop-types,
			}),
			sys: object, // eslint-disable-line react/forbid-prop-types,
		}),
	),
};

export default RecommendedVideos;
